import { Link } from "react-router-dom";
import { hotKeywords } from "@/mocks/keywords";

export default function TickerStrip() {
  const words = [...hotKeywords].sort((a, b) => b.heat - a.heat).slice(0, 10);
  const loop = [...words, ...words];

  return (
    <div className="overflow-hidden border-b border-background-200/70 bg-foreground-950">
      <div className="flex items-center">
        <span className="z-10 flex shrink-0 items-center gap-2 bg-primary-500 px-4 py-2.5 text-xs font-medium text-background-50">
          <i className="ri-radar-line text-accent-300" />
          实时热度
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center gap-6 px-6 py-2.5">
            {loop.map((keyword, index) => (
              <Link
                key={`${keyword.word}-${index}`}
                to={`/keywords?q=${encodeURIComponent(keyword.word)}`}
                className="flex shrink-0 items-center gap-2 whitespace-nowrap text-xs text-background-200 transition-colors hover:text-accent-300"
              >
                <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
                {keyword.word}
                <span className="tabular-nums text-background-400">{keyword.heat}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}